import { CloseOutlined } from '@ant-design/icons';
import { t } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';
import type { Agent } from '../lib/api';
import styles from './AgentDetailPanel.module.css';
import AgentDetailView from './AgentDetailView';

/** Right-side detail panel for an Agent opened from a personal surface. */
export default function AgentDetailPanel({
  agent,
  onClose,
}: {
  agent: Agent;
  onClose: () => void;
}) {
  const { i18n } = useLingui();
  return (
    <div className={styles.root}>
      <button
        type="button"
        className={styles.close}
        aria-label={t(i18n)`Close Agent panel`}
        onClick={onClose}
      >
        <CloseOutlined aria-hidden="true" />
      </button>
      <AgentDetailView agentId={agent.id} agent={agent} />
    </div>
  );
}
